import { hexToRGBA, rgbaToHex } from "../pages/utils/utils";

const emailRegex = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,})$/;
const hexColorRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
const nameRegex = /^[a-zA-Z0-9,+()._ -]*$/;
const businessUnitRegex = /^[a-zA-Z0-9,+()._ ]*$/;
const fileCopyDefaultColor = "#24B7AA";
const iconDefaultColor = "#403E9F";

const colorBrandObject = localStorage.getItem("brandColors") ? JSON.parse(localStorage.getItem("brandColors")) : "#2E2C8D"
const isRgba = /^rgba?\((\d{1,3},\s*){2}\d{1,3}(,\s*\d?(\.\d+)?)?\)$/;
let color = colorBrandObject?.lineGraphColor || '#2E2C8D';
if (colorBrandObject?.lineGraphColor) {
  if (isRgba.test(colorBrandObject?.lineGraphColor)) {
    color = rgbaToHex(colorBrandObject?.lineGraphColor)
  }
}

// const linkStatusPieChartColor = [
//   "#2E2C8D",
//   "#403E9F",
//   "#6664B4",
//   "#A2A0E4",
//   "#C7C6FF",
//   "#CECDFF",
// ];

const linkStatusPieChartColor = [
  hexToRGBA(color, 1),
  hexToRGBA(color, 0.8),
  hexToRGBA(color, 0.6),
  hexToRGBA(color, 0.4),
  hexToRGBA(color, 0.2),
  hexToRGBA(color, 0.1),
];

// const funnelColorSchema = [
//   "#15137E",
//   "#2E2C8D",
//   "#403E9F",
//   "#6664B4",
//   "#A2A0E4",
// ];

const funnelColorSchema = [
  hexToRGBA(color, 1),
  hexToRGBA(color, 0.8),
  hexToRGBA(color, 0.6),
  hexToRGBA(color, 0.4),
  hexToRGBA(color, 0.2),
];

export {
  emailRegex,
  hexColorRegex,
  nameRegex,
  linkStatusPieChartColor,
  funnelColorSchema,
  businessUnitRegex,
  fileCopyDefaultColor,
  iconDefaultColor
};
